import { AvatarUtils } from "../../common/avatar_utils.js";
import { Vector2 } from "../../common/vector2.js";
import { audioController } from "../../audio/audio_controller.js";
import { AudioClips } from "../../audio/audio_constants.js";
import { DialogManager } from "../dialog/dialog_manager.js";
import { ProfileDialog } from "../dialog/profile_dialog.js";
import { ColorScheme } from "./color_scheme.js";
import { UIAvatarSelectionItem } from "./ui_avatar_selection_item.js";
import { UIElementHolder } from "./ui_element_holder.js";

export interface PlayerAvatarOptions
{
  clickable?: boolean;
}

export class PlayerAvatar extends UIElementHolder
{
  private static readonly DEFAULT_X = 50;
  private static readonly DEFAULT_Y = 85;
  private static readonly DEFAULT_SIZE = 180;
  private static readonly BORDER_W = 5;

  private readonly item: UIAvatarSelectionItem;
  private shown_avatar_id: number;

  constructor( ctx: CanvasRenderingContext2D, x: number, y: number, size: number, options: PlayerAvatarOptions = {} )
  {
    const clickable = options.clickable ?? false;

    super( ctx, x, y, size, size, false, clickable );

    this.shown_avatar_id = PlayerAvatar.savedAvatarId();

    const border_w = LayoutScaler.widthFromDesign( PlayerAvatar.BORDER_W );

    this.item = new UIAvatarSelectionItem(
      ctx,
      0,
      0,
      size,
      size,
      this.shown_avatar_id,
      () => {},
      border_w,
      0,
      undefined,
      false,
      ColorScheme.white,
      PlayerAvatar.savedFacebookUrl()
    );
    this.item.setClickable( false );
    this.addChild( this.item );

    if ( clickable )
      this.setOnClick( () => PlayerAvatar.openProfile() );
    else
      this.setClickable( false );
  }

  public static defaultPosition(): Vector2
  {
    const x = LayoutScaler.xFromDesign( PlayerAvatar.DEFAULT_X );
    const y = LayoutScaler.yFromDesign( PlayerAvatar.DEFAULT_Y );

    return new Vector2( x, y );
  }

  public static defaultSize(): number
  {
    return LayoutScaler.widthFromDesign( PlayerAvatar.DEFAULT_SIZE );
  }

  public static savedAvatarId(): number
  {
    const avatar_id = Number.parseInt( localStorage.getItem( "player_avatar_id" ) ?? "", 10 );
    return Number.isFinite( avatar_id ) ? avatar_id : AvatarUtils.TELEGRAM_AVATAR_ID;
  }

  private static savedFacebookUrl(): string | null
  {
    return localStorage.getItem( "player_facebook_avatar_url" );
  }

  private static openProfile(): void
  {
    void audioController.playSound( AudioClips.UI_CLICK );
    DialogManager.openDialog( new ProfileDialog() );
  }

  public center(): Vector2
  {
    const pos = this.getAbsolutePosition();
    const size = this.getRect().getW();
    return new Vector2( pos.x + size / 2, pos.y + size / 2 );
  }

  public sync(): void
  {
    const avatar_id = PlayerAvatar.savedAvatarId();
    if ( avatar_id === this.shown_avatar_id )
      return;

    this.shown_avatar_id = avatar_id;
    this.item.setAvatarId( avatar_id, PlayerAvatar.savedFacebookUrl() );
    this.forceMakeShouldBeRendered();
  }

  public name(): string
  {
    return "PlayerAvatar";
  }
}
